import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {LoadingPage} from 'shells/loading-page/loading-page';

import {SettingsSidebar} from '../setup/settings-sidebar';

import {useCreateProductCategory} from './graphql/hooks/use-create-product-category';
import {useDeleteProductCategory} from './graphql/hooks/use-delete-product-category';
import {useGetProductCategories} from './graphql/hooks/use-get-product-categories';
import {useUpdateProductCategory} from './graphql/hooks/use-update-product-category';
import {ProductCategoriesTable} from './product-categories-table';

import styles from './product-categories-wrapper.module.css';

export function ProductCategoriesWrapper() {
    const [errorSaving, setErrorSaving] = React.useState<string | null | undefined>(null);
    const {productCategories, isLoading} = useGetProductCategories();
    const {
        createProductCategory,
        isLoading: isCreatingProductCategory,
        error: errorCreatingProductCategory,
    } = useCreateProductCategory();
    const {
        updateProductCategory,
        isLoading: isUpdatingProductCategory,
        error: errorUpdatingProductCategory,
    } = useUpdateProductCategory();
    const {deleteProductCategory, error: errorDeletingProductCategory} = useDeleteProductCategory();

    React.useEffect(() => {
        if (errorCreatingProductCategory) {
            setErrorSaving(errorCreatingProductCategory);
        } else {
            setErrorSaving(null);
        }
    }, [errorCreatingProductCategory]);

    React.useEffect(() => {
        if (errorUpdatingProductCategory) {
            setErrorSaving(errorUpdatingProductCategory);
        } else {
            setErrorSaving(null);
        }
    }, [errorUpdatingProductCategory]);

    React.useEffect(() => {
        if (errorDeletingProductCategory) {
            setErrorSaving(errorDeletingProductCategory);
        } else {
            setErrorSaving(null);
        }
    }, [errorDeletingProductCategory]);

    if (isLoading || !productCategories) {
        return <LoadingPage />;
    }

    return (
        <Stack isHorizontal={true} spacing={16}>
            <div className={styles['sidebar-container']}>
                <SettingsSidebar glossaryKey='/sales/product/categories' noBookmark={true} />
            </div>
            <div className={styles['table-wrapper']}>
                <ProductCategoriesTable
                    productCategories={productCategories}
                    onProductCategoryCreate={createProductCategory}
                    onProductCategoryUpdate={updateProductCategory}
                    onProductCategoryDelete={deleteProductCategory}
                    isSaving={isCreatingProductCategory || isUpdatingProductCategory}
                    errorSaving={errorSaving}
                    setErrorSaving={setErrorSaving}
                />
            </div>
        </Stack>
    );
}
